import type { IconName } from "../../components/ui/Icon";
import type { StructureBrief } from "../../../shared/types";

/** The six lines the page designer is given, in the order they are shown. */
export const BRIEF_LINES: Array<{ key: keyof StructureBrief; label: string; icon: IconName }> = [
  { key: "order", label: "Order of the sections", icon: "list" },
  { key: "columns", label: "Columns", icon: "grid" },
  { key: "opening", label: "The opening", icon: "monitor" },
  { key: "density", label: "Density", icon: "sliders" },
  { key: "typeFeel", label: "Type feel", icon: "type" },
  { key: "mood", label: "Mood", icon: "sun" },
];
